import React from 'react';

import {TBadgeColor} from 'src/components/Badge/constants';

import {TClientStatus} from './definitions';
import * as S from './style';

export type TProps = {
  children: React.ReactNode;
  status: TClientStatus;
  className?: string;
};

export const colorHash: Record<TClientStatus, TBadgeColor> = {
  ACTIVE: 'GREEN',
  BLOCKED: 'RED',
  INACTIVE: 'YELLOW',
};

const ClientBadge = React.memo<TProps>(({children, className, status}) => (
  <S.ClientBadge className={className} color={colorHash[status]}>
    {children}
  </S.ClientBadge>
));

export default ClientBadge;
